<template>
    <div class="iframe-box">
        <a-alert message="本页面建议使用360极速浏览器或Microsoft Edge最新版本，浏览效果更佳。" :closable="true" :banner="true" type="info" />
        <bkNav fontColor="yl" searchStyle="brand" :showSearch="true"
            @bkSearchShow="bkSearchShow" @bkSearchHide="bkSearchHide"
        ></bkNav>

        <a-spin :spinning="spinning" size="large">
            <div :class="bkSearchTabShow?'text-span cur':'text-span'">
                <span @click="textAnalysis(0)"><a src="javascript:;">文本分析</a></span> |
                <span @click="textAnalysis(1)"><a src="javascript:;">远读</a></span> |
                <span @click="textAnalysis(2)"><a src="javascript:;">实体标注</a></span>
            </div>
            <div :class="bkSearchTabShow?'ifeames cur':'ifeames'">
                <iframe id="ifra" width="100%" height="700" 
                    :src="'https://dhc.library.sh.cn/iiifweb/view.html?manifest=' + iiifwebManifest"
                ></iframe>
            </div>
        </a-spin>
    </div>
</template>

<script>
import bkNav from './../nav2'
export default {
    components:{
        bkNav
    },
    data(){
        return{
            iiifwebManifest:'',
            bkSearchTabShow: false,
            spinning: false, // 加载中...
        }
    },
    created(){
        this.$nextTick(()=>{
            this.spinning = true;
            this.getManifest();
        })
    },
    mounted(){
        this.$nextTick(()=>{
            this.iframeEndLoading();
            // 监听iframe中所有点击事件
            this.onListenerAllClick(this);
        })
    },
    methods:{
        textAnalysis(analysisTab){
            let articleUri = document.getElementsByTagName('iframe')[0].contentWindow.document.getElementById("source").innerHTML
            let issueUri = this.$route.params.issueUri
            // this.$router.push({
            //     name:"textAnalysis",
            //     params: {
            //         analysisTab: analysisTab,
            //         issueUri: issueUri||"",
            //         articleUri: issueUri?"":articleUri
            //     }
            // });
            let routeT = this.$router.resolve({
                name:"textAnalysis",
                query:{
                    analysisTab: analysisTab,
                    issueUri: issueUri||"",
                    articleUri: issueUri?"":articleUri
                }
            })
            window.open(routeT.href,'_blank')
        },
        getCanvasPage(manifest, articleUri){ // 获取全文页码
            let params = '?manifest=' + manifest + "&source=" + articleUri;
            this.$axios.get(this.bkCommon.getCanvasPageUrl + params)
            .then((res) => {
                let pageNumber = res.data;
                if(this.isEmpty(pageNumber)) pageNumber = 0;
                this.iiifwebManifest = manifest + '#?c=&m=&s=&cv='+ pageNumber +'&xywh=';
            })
            .catch((err) => {
                console.log(err)
            });
        },
        getManifest(){
            let articleUri = this.getUrlParam('articleUri');
            let manifestsKey = this.getUrlParam('manifestsKey');
            if(this.isEmpty(articleUri)) articleUri = localStorage.articleUri;
            if(this.isEmpty(manifestsKey)) manifestsKey = localStorage.manifestsKey;
            let manifest = this.bkCommon.magazineFullManifests[manifestsKey];
            console.log(manifest)
            this.getCanvasPage(manifest, articleUri);
        },
        iframeEndLoading(){ // 加载结束
            var _this = this
            const iframe = document.querySelector('#ifra')
            // 处理兼容行问题
            if (iframe.attachEvent) {
                iframe.attachEvent('onload', function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                    // R图标事件重写
                    _this.iiifR(_this);
                })
            } 
            else {
                iframe.onload = function () {
                    // iframe加载完毕以后执行操作
                    _this.spinning = false;
                    // R图标事件重写
                    _this.iiifR(_this);
                }
            }
        },
        bkSearchShow(visible){ // 高级检索展开
            this.bkSearchTabShow = visible;
            this.unScroll(); // 禁止滚动条滚动
        },
        bkSearchHide(visible){ // 高级检索关闭
            this.bkSearchTabShow = visible;
            this.removeUnScroll(); // 移除禁止滚动条滚动
        }
    }
}
</script>

<style lang="less" scoped>
.iframe-box{
    width: 100%;
    min-height: calc(100vh);
    background:#e3e3e3;
    .text-span{
        width: 90%;
        text-align: right;
        margin: 0 auto;
        margin-bottom: 10px;
        font-size: 12px;
        &.cur{
            opacity: 0.1;
        }
    }
    .ifeames{
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0 auto;
        border-radius: 15px;
        &.cur{
            opacity: 0.1;
        }
        iframe{
            border: none;
        }
    }
}
</style>